var map = {
	"./account-circle.svg": "Q+Lj",
	"./chevron-down.svg": "BSdL",
	"./chevron-left.svg": "7RId",
	"./chevron-right.svg": "9OQQ",
	"./chevron-up.svg": "NlGM",
	"./close.svg": "xofd",
	"./exclamation.svg": "LpZc",
	"./home.svg": "s2D/",
	"./info.svg": "TV5B",
	"./keg.svg": "S35x",
	"./loader.svg": "YoSI",
	"./logout.svg": "TYkI",
	"./menu.svg": "+n/P",
	"./minus.svg": "J1Ic",
	"./pencil.svg": "AefZ",
	"./pint.svg": "gvtp",
	"./plus.svg": "kv8w",
	"./tick.svg": "GnHr"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "26FX";


//////////////////
// WEBPACK FOOTER
// ./components/icon/svg ^\.\/.*$
// module id = 26FX
// module chunks = 0